'use es6';

export const addOrRemoveClassesToElement = (element, previousClasses, currentClasses) => {
  // Sometimes the React tree state and the DOM tree state can get out of sync, causing the diffing of
  // current and previous classes to not line up with what we want. This brute force method of removing
  // all the previous classes and making sure we add all the ones we desire helps account for that state mismatch.
  if (previousClasses && previousClasses.length) {
    element.classList.remove(...previousClasses);
  }
  if (currentClasses && currentClasses.length) {
    element.classList.add(...currentClasses);
  }
};
export const emptyChildrenFromElement = element => {
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
};